module.exports = "/_next/static/images/OgStateOfPersonalizationReport2022-ee1e27acda25112b757f2f8bac71d30f.png";